module.exports = __webpack_public_path__ + "static/media/commercial.6422bdb3.png";